import { QuoteLevelEnum } from "../_common/enum/quoteLevel.enum";
import { BrandEnum } from "../_common/enum/brand.enum";
import { handleErrorResponse } from "./handleResponse.helper";
import { quoteProviderPriceService } from "../_services/quoteProviderPrice.service";
import { redirectToClientPortalAfterApply } from "./clientAppUrl.helper";
import { getBrandCallbackLink } from "./brand.helper";

export type CustomerQuoteApplyRow = {
    providerId?: number;
    providerQuote?: number;
    quoteProviderPriceId?: number;
    quoteRef?: string | null;
    quoteLevel?: number | string;
};

const QUOTE_LEVEL_ID: Record<QuoteLevelEnum, number> = {
    [QuoteLevelEnum.Regular]: 1,
    [QuoteLevelEnum.Bronze]: 2,
    [QuoteLevelEnum.Silver]: 3,
    [QuoteLevelEnum.Gold]: 4,
};

function resolveQuoteLevelId(quote: CustomerQuoteApplyRow, quoteLevel?: QuoteLevelEnum) {
    if (quoteLevel) return QUOTE_LEVEL_ID[quoteLevel];
    if (typeof quote.quoteLevel === "number" && quote.quoteLevel > 0) return quote.quoteLevel;
    if (typeof quote.quoteLevel === "string" && QUOTE_LEVEL_ID[quote.quoteLevel as QuoteLevelEnum]) {
        return QUOTE_LEVEL_ID[quote.quoteLevel as QuoteLevelEnum];
    }
    return QUOTE_LEVEL_ID[QuoteLevelEnum.Regular];
}

export function runCustomerAppQuoteApply(params: {
    quote: CustomerQuoteApplyRow;
    quoteId: number;
    brand: BrandEnum;
    quoteLevel?: QuoteLevelEnum;
    onRequestCallback?: () => void;
}) {
    const price = Number(params.quote.providerQuote ?? 0);
    if (price <= 0) {
        if (params.onRequestCallback) {
            params.onRequestCallback();
            return Promise.resolve();
        }
        window.open(getBrandCallbackLink(params.brand), "_blank", "noopener,noreferrer");
        return Promise.resolve();
    }

    const quoteLevel = resolveQuoteLevelId(params.quote, params.quoteLevel);
    return quoteProviderPriceService
        .updateOnApply({
            ...params.quote,
            quoteId: params.quoteId,
            quoteLevel,
            quoteRef: params.quote.quoteRef ?? "",
        })
        .then((json) => {
            redirectToClientPortalAfterApply(json, {
                quoteId: params.quoteId,
                brandId: params.brand,
            });
        }, handleErrorResponse);
}

export function runCustomerAppMortgageApply(params: {
    mortgageProductRateId: number;
    quoteId: number;
    brand: BrandEnum;
}) {
    const newTab = window.open("about:blank");
    if (!newTab) {
        alert("Popup blocked. Please allow popups in your browser.");
        return Promise.resolve();
    }

    return quoteProviderPriceService
        .updateOnApplyForMortgage(params.mortgageProductRateId, params.quoteId)
        .then(() => {
            newTab.location.href = "https://lowquotes.creditlogic.io/";
        }, handleErrorResponse);
}
